import React from 'react';
import ToolTip from "storybookComponents/Tooltip"
import Icon from "storybookComponents/Icon";
import withStyles from "@material-ui/core/styles/withStyles";
import styles from "./style.js"
const ViewNavigation = ({ classes, onTodayClick, onClickMonth, monthContent, onClickYear, yearContent, onClickPrev, onClickSwitch, onClickNext, switchContent, switchColSpan, switchProps }) => {
	return (
		<tr>
			<th colSpan={7}>
				<div className={classes.topContainer}>
					<div className={classes.leftContainer}>
						{
							monthContent ?
								<div className={classes.monthView} onClick={onClickMonth} ><span className={classes.leftMargin}>{monthContent}</span>	<Icon size="xs" type="icon-down-arrow" /></div> : null
						}
						{
							yearContent ?
								<div className={classes.yearView} onClick={onClickYear} ><span className={classes.leftMargin}> 	{yearContent}	</span><Icon size="xs" type="icon-down-arrow" /></div> : null
						}
					</div>
					<div className={classes.rightContainer}>
						{
							yearContent ?
								<div className="rdtPrev" onClick={onClickPrev}>
									<ToolTip className={classes.tooltip} tooltip_text={monthContent ? "Previous Month" : "Previous Decade"}
										placement="bottom">	<Icon className={classes.colorIcon} size="xs" type="icon-left-arrow" /></ToolTip>
								</div> : null
						}
						<div className={`rdtPrev ${classes.alignMent}`} onClick={onTodayClick}>
							<ToolTip tooltip_text="Today"
								placement="bottom">	<div className={classes.dimondIcon} ></div></ToolTip>
						</div>
						{
							yearContent ?
								<div className="rdtNext" onClick={onClickNext}>
									<ToolTip tooltip_text={monthContent ? "Next Month" : "Next Decade"} placement="bottom">
										<Icon className={classes.colorIcon} size="xs" type="icon-right-arrow" />
									</ToolTip>
								</div>
								: null
						}
					</div>
				</div>
			</th>
		</tr >
	);
}

export default (withStyles)(styles)(ViewNavigation);